export default __webpack_public_path__ + "static/media/lose.c7ccfc1d.gif";